module.exports = __webpack_public_path__ + "static/img/12012D_2_3_7_8_11_12_R_20190811_fit.eb1f03d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12012D_2_3_7_8_11_12_R_20190811_fit.png
// module id = AU1h
// module chunks = 0